export default __webpack_public_path__ + "static/media/groups.0e3385c0.svg";